import slugify from './slugify'

const MEMO = {}

// Guide slugs are used by user-onboarding scripts to locate and
// highlight Links / Buttons etc.
// Guide slugs may also be useful for automated testing.
export default function generateGuideSlug(placement, name) {
    const key = `guide-${placement}-${name}`

    if (Object.prototype.hasOwnProperty.call(MEMO, key)) {
        return MEMO[key]
    }

    // slugify is a bit costly to run
    const guideslug = slugify(key)

    MEMO[key] = guideslug
    return guideslug
}
